/* pp-portal-media.js — Première Peau Partner Portal: the media library manifest.
   Every item here is an asset that is already live on premierepeau.com or a signed
   document that already travels with the goods. Nothing is invented, nothing is
   upscaled, and the real pixel size and weight of every file is printed on its tile
   so nobody downloads a 400px thumbnail believing it is a print master.

   Curation rule (anti-AI-slop): a file earns a tile only if it is (a) production
   material we shipped, and (b) legible at the size it claims. Web-size stills are
   labelled web-size. Files that name a supplier, a fragrance house or a filler are
   excluded outright and never reach this list.

   English lives inline. PP_PORTAL_I18N[locale]['m.<key>.n'] overrides a name,
   ['m.<key>.d'] overrides the note. A missing key degrades to English, never blank.

   a  = theme asset filename (resolved to a CDN url by the Liquid section)
   p  = poster asset filename for a video tile
   g  = group   s = scent   t = kind
   w/h = real pixels   dur = real seconds   b = real bytes */

(function (w) {
  'use strict';

  var GROUPS = [
    { k: 'campaigns', n: 'Campaigns',
      d: 'Films, loops and campaign stills as they ran. Sixteen-by-nine for screens and shop windows, nine-by-sixteen for phones and vertical totems.' },
    { k: 'packshots', n: 'Packshots & co',
      d: 'Bottles on white and on gradient, plus the ingredient stills. The bottle files are the same ones the storefront serves, so what you publish matches what a customer sees.' },
    { k: 'inci',      n: 'INCI & co',
      d: 'The safety data sheet carries the full composition, the hazard classification and the transport entry. It is the document your regulatory affairs and your customs broker both ask for.' },
    { k: 'brand',     n: 'Brand & press',
      d: 'The wordmark, the roundel, the perfumers and the rooms. Use the wordmark as supplied — please do not re-draw it, re-space it or set it in another typeface.' }
  ];

  var SCENTS = [
    { k: 'house',    n: 'House' },
    { k: 'albatre',  n: 'Albâtre Sépia' },
    { k: 'doppel',   n: 'Doppel Dancers' },
    { k: 'gravitas', n: 'Gravitas Capitale' },
    { k: 'insuline', n: 'Insuline Safrine' },
    { k: 'nuit',     n: 'Nuit Élastique' },
    { k: 'rose',     n: 'Rose Monotone' },
    { k: 'simili',   n: 'Simili Mirage' }
  ];

  var KINDS = [
    { k: 'film',     n: 'Films' },
    { k: 'loop',     n: 'Loops' },
    { k: 'still',    n: 'Stills' },
    { k: 'packshot', n: 'Packshots' },
    { k: 'doc',      n: 'Documents' },
    { k: 'logo',     n: 'Logos' }
  ];

  var ITEMS = [
    /* ------------------------------------------------------------- campaigns */
    { k: 'grav_film', g: 'campaigns', s: 'gravitas', t: 'film',
      a: 'creative-works-gravitas-film.mp4', p: 'pp-poster-grav-film.jpg',
      n: 'Gravitas Capitale — film', w: 1280, h: 720, dur: 61, b: 6021144,
      d: 'The long cut. Cold glass architecture, no voice-over, no on-screen price. Runs on a shop screen without sound.' },
    { k: 'grav_film_m', g: 'campaigns', s: 'gravitas', t: 'film',
      a: 'creative-works-gravitas-film-mobile.mp4', p: 'pp-poster-grav-film-m.jpg',
      n: 'Gravitas Capitale — film, vertical', w: 720, h: 1280, dur: 61, b: 6338094,
      d: 'Same film framed nine-by-sixteen for stories and vertical totems.' },
    { k: 'grav_loop', g: 'campaigns', s: 'gravitas', t: 'loop',
      a: 'creative-works-gravitas-loop.mp4', p: 'pp-poster-grav-loop.jpg',
      n: 'Gravitas Capitale — loop', w: 1280, h: 720, dur: 12, b: 2032100,
      d: 'Twelve seconds, seamless. Built to hang on a wall screen all day.' },
    { k: 'grav_loop_m', g: 'campaigns', s: 'gravitas', t: 'loop',
      a: 'creative-works-gravitas-loop-mobile.mp4', p: 'pp-poster-grav-loop-m.jpg',
      n: 'Gravitas Capitale — loop, vertical', w: 720, h: 1280, dur: 12, b: 2039665,
      d: 'The vertical cut of the same loop.' },

    { k: 'nuit_film', g: 'campaigns', s: 'nuit', t: 'film',
      a: 'creative-works-nuit-film.mp4', p: 'pp-poster-nuit-film.jpg',
      n: 'Nuit Élastique — film', w: 1280, h: 720, dur: 60, b: 5397970,
      d: 'The long cut. Subtitles ship as a separate WebVTT track if you need them burned in locally.' },
    { k: 'nuit_film_m', g: 'campaigns', s: 'nuit', t: 'film',
      a: 'creative-works-nuit-film-mobile.mp4', p: 'pp-poster-nuit-film-m.jpg',
      n: 'Nuit Élastique — film, vertical', w: 720, h: 1280, dur: 60, b: 5338961,
      d: 'Nine-by-sixteen cut of the film.' },
    { k: 'nuit_loop', g: 'campaigns', s: 'nuit', t: 'loop',
      a: 'creative-works-nuit-loop.mp4', p: 'pp-poster-nuit-loop.jpg',
      n: 'Nuit Élastique — loop', w: 1280, h: 720, dur: 12, b: 1652306,
      d: 'Twelve seconds, seamless, silent.' },
    { k: 'nuit_loop_m', g: 'campaigns', s: 'nuit', t: 'loop',
      a: 'creative-works-nuit-loop-mobile.mp4', p: 'pp-poster-nuit-loop-m.jpg',
      n: 'Nuit Élastique — loop, vertical', w: 720, h: 1280, dur: 12, b: 1523603,
      d: 'The vertical cut of the same loop.' },

    { k: 'simi_loop', g: 'campaigns', s: 'simili', t: 'loop',
      a: 'creative-works-simili-loop.mp4', p: 'pp-poster-simi-loop.jpg',
      n: 'Simili Mirage — loop', w: 1280, h: 720, dur: 12, b: 1535849,
      d: 'Twelve seconds, seamless, silent.' },
    { k: 'simi_loop_m', g: 'campaigns', s: 'simili', t: 'loop',
      a: 'creative-works-simili-loop-mobile.mp4', p: 'pp-poster-simi-loop-m.jpg',
      n: 'Simili Mirage — loop, vertical', w: 720, h: 1280, dur: 12, b: 1766364,
      d: 'The vertical cut of the same loop.' },

    { k: 'hero_dopp', g: 'campaigns', s: 'doppel', t: 'film',
      a: 'signature-works-hero-desktop.mp4', p: 'pp-poster-hero-doppel.jpg',
      n: 'Doppel Dancers — hero', w: 1440, h: 810, dur: 20, b: 2130729,
      d: 'The film that opens the homepage. Twenty seconds, no cut to a product shot at the end.' },
    { k: 'hero_dopp_m', g: 'campaigns', s: 'doppel', t: 'film',
      a: 'signature-works-hero-mobile.mp4', p: 'pp-poster-hero-doppel-mobile.jpg',
      n: 'Doppel Dancers — hero, vertical', w: 720, h: 1280, dur: 20, b: 2107731,
      d: 'The vertical cut of the homepage film.' },
    { k: 'hero_nuit_v', g: 'campaigns', s: 'nuit', t: 'film',
      a: 'pp-homepage-hero-2-desktop-optimized.mp4', p: 'pp-poster-hero-nuit-vertical.jpg',
      n: 'Nuit Élastique — hero, vertical', w: 606, h: 1080, dur: 10, b: 831342,
      d: 'Ten seconds. Black dunes, then the bottle in the hand.' },

    { k: 'band_grav', g: 'campaigns', s: 'gravitas', t: 'loop',
      a: 'gravitas.mp4', p: 'pp-poster-band-gravitas.jpg',
      n: 'Gravitas Capitale — banner strip', w: 720, h: 288, dur: 8, b: 374138,
      d: 'Wide letterbox strip for a header band or a shelf rail screen. Small file on purpose.' },
    { k: 'band_nuit', g: 'campaigns', s: 'nuit', t: 'loop',
      a: 'nuit-elastique.mp4', p: 'pp-poster-band-nuit.jpg',
      n: 'Nuit Élastique — banner strip', w: 720, h: 288, dur: 8, b: 210040,
      d: 'Wide letterbox strip for a header band or a shelf rail screen.' },
    { k: 'band_rose', g: 'campaigns', s: 'rose', t: 'loop',
      a: 'rose-monotone.mp4', p: 'pp-poster-band-rose.jpg',
      n: 'Rose Monotone — banner strip', w: 720, h: 288, dur: 8, b: 339675,
      d: 'Wide letterbox strip for a header band or a shelf rail screen.' },
    { k: 'band_simi', g: 'campaigns', s: 'simili', t: 'loop',
      a: 'simili-mirage.mp4', p: 'pp-poster-band-simili.jpg',
      n: 'Simili Mirage — banner strip', w: 720, h: 288, dur: 7, b: 226184,
      d: 'Wide letterbox strip for a header band or a shelf rail screen.' },

    { k: 'nuit_edito', g: 'campaigns', s: 'nuit', t: 'still',
      a: 'creative-works-nuit-editorial.jpg',
      n: 'Nuit Élastique — editorial', w: 960, h: 1440, b: 186571,
      d: 'The paper-tuberose set. Portrait crop, works as a full page or a window print at A2.' },
    { k: 'nuit_award', g: 'campaigns', s: 'nuit', t: 'still',
      a: 'creative-works-nuit-award.jpg',
      n: 'Nuit Élastique — Art & Olfaction winner', w: 1692, h: 840, b: 74571,
      d: 'The award card. Use it on a shelf talker or a newsletter; the mark belongs to the Institute for Art and Olfaction, so keep it whole and do not re-colour it.' },
    { k: 'grav_still', g: 'campaigns', s: 'gravitas', t: 'still',
      a: 'creative-works-gravitas-poster.jpg',
      n: 'Gravitas Capitale — campaign still', w: 1280, h: 720, b: 72117,
      d: 'Sixteen-by-nine still pulled from the film. Web size — ask if you need it for print.' },
    { k: 'nuit_still', g: 'campaigns', s: 'nuit', t: 'still',
      a: 'creative-works-nuit-poster.jpg',
      n: 'Nuit Élastique — campaign still', w: 1280, h: 720, b: 50980,
      d: 'Sixteen-by-nine still pulled from the film. Web size — ask if you need it for print.' },
    { k: 'simi_still', g: 'campaigns', s: 'simili', t: 'still',
      a: 'creative-works-simili-poster.jpg',
      n: 'Simili Mirage — campaign still', w: 1280, h: 720, b: 70828,
      d: 'Sixteen-by-nine still pulled from the film. Web size — ask if you need it for print.' },
    { k: 'rose_chrome', g: 'campaigns', s: 'rose', t: 'still',
      a: 'poster-chrome-blooms.jpg',
      n: 'Rose Monotone — chrome study', w: 1290, h: 720, b: 234928,
      d: 'The chromed thistle field. A material study, not a product shot — it reads as an art card, not as a shelf image.' },
    { k: 'house_cafe', g: 'campaigns', s: 'house', t: 'still',
      a: 'poster-jasmine.jpg',
      n: 'House — terrace still', w: 1920, h: 1080, b: 250574,
      d: 'A blotter on a Paris terrace. Quiet editorial filler for a newsletter or a story background.' },

    /* ------------------------------------------------------------- packshots */
    { k: 'grav_reveal', g: 'packshots', s: 'gravitas', t: 'packshot',
      a: 'creative-works-gravitas-reveal.jpg',
      n: 'Gravitas Capitale — bottle on gradient', w: 1600, h: 2133, b: 149997,
      d: 'Three-by-four portrait. The cap glyph and the label are sharp at full size.' },
    { k: 'simi_reveal', g: 'packshots', s: 'simili', t: 'packshot',
      a: 'creative-works-simili-reveal.jpg',
      n: 'Simili Mirage — bottle on gradient', w: 1600, h: 2133, b: 152486,
      d: 'Three-by-four portrait. The cap glyph and the label are sharp at full size.' },

    { k: 'tot_albatre', g: 'packshots', s: 'albatre', t: 'still',
      a: 'totem-albatre.jpg', n: 'Albâtre Sépia — ingredient still', w: 400, h: 400, b: 8753,
      d: 'White truffle on black. Web size, 400 pixels square — fine for a listing icon, not for print.' },
    { k: 'tot_doppel', g: 'packshots', s: 'doppel', t: 'still',
      a: 'totem-doppel.jpg', n: 'Doppel Dancers — ingredient still', w: 400, h: 400, b: 9178,
      d: 'Iris on black. Web size, 400 pixels square — fine for a listing icon, not for print.' },
    { k: 'tot_gravitas', g: 'packshots', s: 'gravitas', t: 'still',
      a: 'totem-gravitas.jpg', n: 'Gravitas Capitale — ingredient still', w: 400, h: 400, b: 13120,
      d: 'Cedrat on black. Web size, 400 pixels square — fine for a listing icon, not for print.' },
    { k: 'tot_insuline', g: 'packshots', s: 'insuline', t: 'still',
      a: 'totem-insuline.jpg', n: 'Insuline Safrine — ingredient still', w: 400, h: 400, b: 7645,
      d: 'Saffron on black. Web size, 400 pixels square — fine for a listing icon, not for print.' },
    { k: 'tot_nuit', g: 'packshots', s: 'nuit', t: 'still',
      a: 'totem-nuit.jpg', n: 'Nuit Élastique — ingredient still', w: 400, h: 400, b: 4270,
      d: 'Jasmine on black. Web size, 400 pixels square — fine for a listing icon, not for print.' },
    { k: 'tot_rose', g: 'packshots', s: 'rose', t: 'still',
      a: 'totem-rose.jpg', n: 'Rose Monotone — ingredient still', w: 400, h: 400, b: 5102,
      d: 'Lychee on black. Web size, 400 pixels square — fine for a listing icon, not for print.' },
    { k: 'tot_simili', g: 'packshots', s: 'simili', t: 'still',
      a: 'totem-simili.jpg', n: 'Simili Mirage — ingredient still', w: 400, h: 400, b: 8734,
      d: 'Leather on black. Web size, 400 pixels square — fine for a listing icon, not for print.' },

    /* ----------------------------------------------------------------- INCI */
    { k: 'sds_albatre', g: 'inci', s: 'albatre', t: 'doc', doc: true,
      a: 'pp-doc-sds-albatre-sepia.pdf', n: 'Albâtre Sépia — safety data sheet', pages: 5, b: 356430,
      d: 'Full INCI, hazard classification, first aid, storage and the transport entry. English, revision 01, June 2025.' },
    { k: 'sds_doppel', g: 'inci', s: 'doppel', t: 'doc', doc: true,
      a: 'pp-doc-sds-doppel-dancers.pdf', n: 'Doppel Dancers — safety data sheet', pages: 5, b: 354853,
      d: 'Full INCI, hazard classification, first aid, storage and the transport entry. English, revision 01, June 2025.' },
    { k: 'sds_gravitas', g: 'inci', s: 'gravitas', t: 'doc', doc: true,
      a: 'pp-doc-sds-gravitas-capitale.pdf', n: 'Gravitas Capitale — safety data sheet', pages: 5, b: 359354,
      d: 'Full INCI, hazard classification, first aid, storage and the transport entry. English, revision 01, June 2025.' },
    { k: 'sds_insuline', g: 'inci', s: 'insuline', t: 'doc', doc: true,
      a: 'pp-doc-sds-insuline-safrine.pdf', n: 'Insuline Safrine — safety data sheet', pages: 5, b: 355698,
      d: 'Full INCI, hazard classification, first aid, storage and the transport entry. English, revision 01, June 2025.' },
    { k: 'sds_nuit', g: 'inci', s: 'nuit', t: 'doc', doc: true,
      a: 'pp-doc-sds-nuit-elastique.pdf', n: 'Nuit Élastique — safety data sheet', pages: 5, b: 356266,
      d: 'Full INCI, hazard classification, first aid, storage and the transport entry. English, revision 01, June 2025.' },
    { k: 'sds_rose', g: 'inci', s: 'rose', t: 'doc', doc: true,
      a: 'pp-doc-sds-rose-monotone.pdf', n: 'Rose Monotone — safety data sheet', pages: 5, b: 354405,
      d: 'Full INCI, hazard classification, first aid, storage and the transport entry. English, revision 01, June 2025.' },
    { k: 'sds_simili', g: 'inci', s: 'simili', t: 'doc', doc: true,
      a: 'pp-doc-sds-simili-mirage.pdf', n: 'Simili Mirage — safety data sheet', pages: 5, b: 354860,
      d: 'Full INCI, hazard classification, first aid, storage and the transport entry. English, revision 01, June 2025.' },
    { k: 'doc_fda', g: 'inci', s: 'house', t: 'doc', doc: true,
      a: 'pp-doc-fda-registration.pdf', n: 'FDA cosmetic registration certificate', pages: 1, b: 304477,
      d: 'The seven listing numbers filed under the Modernization of Cosmetics Regulation Act, with Première Peau SAS as responsible person. What a US buyer asks for first.' },

    /* ---------------------------------------------------------------- brand */
    { k: 'logo_master', g: 'brand', s: 'house', t: 'logo', bg: 'light',
      a: 'pp-brand-wordmark-master.png', n: 'Wordmark — master, transparent', w: 10394, h: 3307, b: 85532,
      d: 'The wordmark at full size on a transparent ground. This is the file to give a printer.' },
    { k: 'logo_black', g: 'brand', s: 'house', t: 'logo', bg: 'light',
      a: 'pp-brand-wordmark-black.png', n: 'Wordmark — black, transparent', w: 2275, h: 218, b: 11928,
      d: 'For light grounds. Screen size.' },
    { k: 'logo_white', g: 'brand', s: 'house', t: 'logo', bg: 'dark',
      a: 'pp-logo-white.png', n: 'Wordmark — white, transparent', w: 474, h: 45, b: 2189,
      d: 'For dark grounds. Small — take the master and invert it if you need it large.' },
    { k: 'logo_roundel', g: 'brand', s: 'house', t: 'logo', bg: 'light',
      a: 'pp-brand-roundel.png', n: 'Roundel — the cap glyph', w: 1000, h: 1000, b: 60688,
      d: 'The registered mark, the same glyph engraved on the cap. Square, transparent.' },

    { k: 'p_claire', g: 'brand', s: 'house', t: 'still',
      a: 'portrait-claire.jpg', n: 'Claire Liégent — perfumer', w: 800, h: 1120, b: 171640,
      d: 'Credit the perfumer by name wherever you run the portrait. Ask us which signature to name alongside it.' },
    { k: 'p_florian', g: 'brand', s: 'house', t: 'still',
      a: 'portrait-florian.jpg', n: 'Florian Gallo — perfumer', w: 800, h: 1120, b: 265772,
      d: 'Credit the perfumer by name wherever you run the portrait. Ask us which signature to name alongside it.' },
    { k: 'p_gregoire', g: 'brand', s: 'house', t: 'still',
      a: 'portrait-gregoire.jpg', n: 'Grégoire Balleydier — perfumer', w: 800, h: 1120, b: 265546,
      d: 'Credit the perfumer by name wherever you run the portrait. Ask us which signature to name alongside it.' },
    { k: 'p_ugo', g: 'brand', s: 'house', t: 'still',
      a: 'portrait-ugo.jpg', n: 'Ugo Charron — perfumer', w: 800, h: 1120, b: 257468,
      d: 'Credit the perfumer by name wherever you run the portrait. Ask us which signature to name alongside it.' },
    { k: 'p_pierre', g: 'brand', s: 'house', t: 'still',
      a: 'portrait-pierre.jpg', n: 'The founder', w: 800, h: 1120, b: 263903,
      d: 'Deliberately out of focus. Please run it as supplied.' },

    { k: 'r_gl', g: 'brand', s: 'house', t: 'still',
      a: 'pr-press-gl.jpg', n: 'Room — Galeries Lafayette', w: 746, h: 1000, b: 136361,
      d: 'Retail context for a press page or a deck.' },
    { k: 'r_printemps', g: 'brand', s: 'house', t: 'still',
      a: 'pr-press-printemps.jpg', n: 'Room — Printemps', w: 746, h: 1000, b: 248721,
      d: 'Retail context for a press page or a deck.' },
    { k: 'r_pitti', g: 'brand', s: 'house', t: 'still',
      a: 'pr-press-pitti.jpg', n: 'Room — Pitti Fragranze', w: 746, h: 1000, b: 148345,
      d: 'Trade context for a press page or a deck.' },
    { k: 'r_skins', g: 'brand', s: 'house', t: 'still',
      a: 'pr-press-skins.jpg', n: 'Room — white gallery', w: 746, h: 1000, b: 65575,
      d: 'Neutral interior. Useful as a quiet background plate.' },
    { k: 'r_inja', g: 'brand', s: 'house', t: 'still',
      a: 'pr-press-inja.jpg', n: 'Room — Haussmann interior', w: 746, h: 1000, b: 101739,
      d: 'Paris interior. Useful as a quiet background plate.' },
    { k: 'r_coverage', g: 'brand', s: 'house', t: 'still',
      a: 'pr-press-coverage.jpg', n: 'Press — the stack', w: 746, h: 1000, b: 105635,
      d: 'Editorial coverage as an object. For a press or about page.' },
    { k: 'r_award', g: 'brand', s: 'house', t: 'still',
      a: 'pr-press-award-ao.jpg', n: 'Press — the bud on stone', w: 746, h: 1000, b: 81360,
      d: 'Still life. For a press or about page.' },
    { k: 'r_tff', g: 'brand', s: 'insuline', t: 'still',
      a: 'pr-press-tff.jpg', n: 'Press — saffron', w: 746, h: 1000, b: 118067,
      d: 'Saffron at close range. For a press or about page.' }
  ];

  /* Transport and customs facts, taken verbatim from the safety data sheets and
     from the live variant records. Nothing here is estimated. */
  var TRANSPORT = [
    { k: 'hs',      n: 'Customs tariff heading', v: '3303 00' },
    { k: 'un',      n: 'UN number',              v: 'UN 1993' },
    { k: 'class',   n: 'Transport class',        v: 'Class 3 — flammable liquid' },
    { k: 'pg',      n: 'Packing group',          v: 'II' },
    { k: 'ghs',     n: 'Pictogram',              v: 'GHS02' },
    { k: 'hstat',   n: 'Hazard statement',       v: 'H225 — highly flammable liquid and vapour' },
    { k: 'clp',     n: 'CLP',                    v: 'Finished cosmetic, exempt under (EC) 1272/2008' },
    { k: 'reg',     n: 'Cosmetic regulation',    v: '(EC) No 1223/2009' },
    { k: 'origin',  n: 'Country of origin',      v: 'France' }
  ];

  w.PP_PORTAL_MEDIA = { GROUPS: GROUPS, SCENTS: SCENTS, KINDS: KINDS, ITEMS: ITEMS, TRANSPORT: TRANSPORT };
})(window);
